export default document.querySelector('#vbs-modal-container')!;
